import * as S from './styles';

export type CarouselIndicatorProps = {
  $totalImagens: number;
  $currentSlide: number;
  // eslint-disable-next-line no-unused-vars
  $onClickIndicator?: (indiceBolinha: number) => void;
  $indexValorAjuda?: number;
};

export default function CarouselIndicator(props: CarouselIndicatorProps) {
  const {
    $totalImagens,
    $currentSlide,
    $onClickIndicator = () => {},
    $indexValorAjuda = 0,
  } = props;
  return (
    <S.DotsContainer>
      {Array.from({ length: $totalImagens }).map((_, index) => (
        <S.Indicator
          onClick={() => $onClickIndicator(index + $indexValorAjuda)}
          key={index}
          $isActive={index + $indexValorAjuda === $currentSlide}
        />
      ))}
    </S.DotsContainer>
  );
}
